import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import axios from "axios";
import { createForm } from "rc-form";
import * as React from "react";
import { Config } from "../../../../config/config";
import { Helpers } from "../../../../utils/helpers";

interface NewFolderSate {
    modalVisible: boolean;
    isLoaded: boolean;
    creatingFolder: boolean;
    userBundles: any[];
    usersList: any[];
    error: null | string;
}

interface NewFolderProps {
    buttonText?: string;
    currentDirectory: string;
    refreshParent(): void;
    activeBundleId: string;
    form: any;
}

class NewFolderModalFormWrapped extends React.Component<NewFolderProps, NewFolderSate> {

    constructor(props) {
        super(props);

        this.state = {
            modalVisible: false,
            isLoaded: false,
            error: null,
            creatingFolder: false,
            userBundles: [],
            usersList: [],
        };
    }

    /**
     * Callback function for create button
     * Calling this function a modal will be shown
     */
    onModalShow = () => {
        this.setState({
            modalVisible: true,
        });
    }

    onModalClose = () => {
        this.setState({
            modalVisible: false,
            error: null,
        }, () => {
            // Reset form values
            this.props.form.resetFields();
        });
    }

    handleModalCreate = () => {
        const { form } = this.props;

        form.validateFields((err, values) => {
            if (err) {
                return;
            }

            this.setState({
                creatingFolder: true,
            }, () => {
                axios.post(`${Config.getInstance.apiUrl}/api/bundle/folder`, {
                    folderName: values.folder_name,
                    description: values.description,
                    currentDir: this.props.currentDirectory,
                    bundleId: this.props.activeBundleId,
                    hideFingerprint: values.hide_fingerprint,
                }, {
                    headers: {
                        Authorization: Helpers.getSessionId(),
                    },
                }).then((result) => {
                    // Reset form fields
                    form.resetFields();
                    // Otherwise load and show a list with applications
                    return this.setState({
                        creatingFolder: false,
                        modalVisible: false,
                    }, () => {
                        // Refresh parent component
                        this.props.refreshParent();
                    });
                }).catch((error) => {
                    this.setState({
                        error: error.response.statusText,
                        creatingFolder: false,
                    });
                });
            });
        });
    }
    render() {
        const { getFieldDecorator } = this.props.form;

        return (
            <React.Fragment>
                <Button disableElevation onClick={this.onModalShow} color="primary" size="small" variant="contained">
                    {this.props.buttonText}
                </Button>

                <Dialog
                    open={this.state.modalVisible}
                    onClose={this.onModalClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">Create folder</DialogTitle>
                    <DialogContent style={{ overflow: "hidden" }}>
                        <div>
                            {getFieldDecorator("folder_name",
                                {rules: [{
                                    required: true,
                                    message: "Please enter folder name",
                                }]},
                            )(
                                <TextField
                                    label="Folder name"
                                    margin="normal"
                                    style={{ width: "100%" }}
                                />,
                            )}

                            {getFieldDecorator("description",
                                {rules: [{
                                    required: true,
                                    message: "Description",
                                }]},
                            )(
                                <TextField
                                    label="Description"
                                    margin="normal"
                                    style={{ width: "100%" }}
                                />,
                            )}
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button disableElevation onClick={this.onModalClose} color="primary">
                            Cancel
                        </Button>

                        <div className="loading-button-wrapper">
                            <Button disableElevation onClick={this.handleModalCreate} color="primary" disabled={this.state.creatingFolder}>
                                Create
                            </Button>

                            {this.state.creatingFolder && <CircularProgress size={24} className="button-progress"/>}
                        </div>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

export const NewFolderModalForm = createForm()(NewFolderModalFormWrapped);
